<template>
  <div class="welcome">
    <div class="welcome__header">
      <h1>Welcome to the Global State of Democracy!</h1>
      <p>Please select a dataset:</p>
    </div>
    <ul class="welcome__navigation" >
      <li class="welcome__navigation__item"><router-link :to="{ name: 'democracy-indices' }">
        <h2>Global State of <br> Democracy Indices</h2>
        <div class="item-bottom">
          <p>
            The Global State of Democracy Indices depict democratic trends at the country, regional and global levels for 165 countries across 29 aspects of democracy from 1975-2021, updated annually.
          </p>
          <div class="icon">
            <ArrowRightIcon :size="15"></ArrowRightIcon>
          </div>
        </div>
      </router-link>
      </li>
      <li class="welcome__navigation__item revert">
        <router-link :to="{ name: 'covid-19-monitor' }">
          <h2>Global Monitor of <br>COVID-19's Impact <br>on Democracy and <br>Human Rights</h2>
          <div class="item-bottom">
            <p>
              The Global Monitor of COVID-19’s Impact on Democracy and Human Rights is a qualitative monitor and a “one-stop-shop” online global monitoring tool/of the democracy and human rights implications of measures adopted by governments around the world in the context of the COVID-19 crisis.
            </p>
            <div class="icon">
              <ArrowRightIcon :size="15"></ArrowRightIcon>
            </div>

          </div>
        </router-link>
      </li>

    </ul>
  </div>
</template>
<script>
import ArrowRightIcon from '../shared/icons/ArrowRightIcon'
export default {
  name: 'welcome',
  components: {
    ArrowRightIcon
  },
  mounted () {
    let li = document.getElementsByClassName('switch-to')
    if (li.length > 0) {
      li[0].remove()
    }
  }
}
</script>

<style lang="scss">
@import '../sass/shared/fonts';

.welcome{
  background:#f1f3f7;
  text-align:center;
  padding:1px;
  font-family: $fontfamily-sans-serif;
  h1{
    font-family: $fontfamily-sans-serif;
  }
  h2{
    font-family: $fontfamily-sans-serif;
  }
  A{
    font-family: $fontfamily-sans-serif;
  }
}

.welcome__header{
  h1{
    font-size:38px;
    margin-bottom: 2px;
  }
  p{
    font-size:23px;
    margin:0;
  }
}
.welcome__navigation{
  display: grid;
  grid-template-rows: 445px;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 85px;
  margin:70px auto;
  padding:0;
  list-style:none;
  max-width: 920px;
}
.welcome__navigation__item{
  text-align: left;
  A {
    background:#10637e;
    color:#ffffff;
    padding:30px 30px;
    text-decoration: none;
    display:flex;
    flex-direction:column;
    justify-content: space-between;
    height: 100%;
    h2{
      margin: 0;
      color: #ffffff;
      font-size: 37px;
      line-height: 1;
      min-height: 150px;
    }
  }
  .icon{
    border-radius:50%;
    background:#ffffff;
    width:55px;
    height:55px;
    display:flex;
    justify-content: center;
    align-items: center;
    svg{
      fill:#10637e;
      width:25px;
    }
  }
  &.revert {
    A{
      background:#ffffff;
      color:#10637e;
      h2{
        color: #10637e;
      }
    }
    .icon{
      background:#10637e;
      color:#ffffff;
      svg{
        fill:#ffffff;
      }
    }
  }
  .item-bottom{
    display:flex;
    flex-direction:column;
    height: 100%;
    justify-content: space-between;
    p{
      line-height:1.7;
      margin-bottom:18px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Welcome.vue